module.exports = __webpack_public_path__ + "images/forza-horizon-4-b_rgba(0,0,0,0.7).jpg?v=8b257cff2e41bfe00584c3f4bd03c2ee";